import { format } from "date-fns";
import { useDateLocale } from "../../i18n/use-date-locale";
import { useScheduleStore } from "../../stores/schedule-store";
import { StreamSlotRow } from "./StreamSlotRow";
import { OfflineMessageRow } from "./OfflineMessageRow";
import { ScheduleSwapArea } from "./ScheduleSwapArea";
import { ScheduleModeTabs } from "./ScheduleModeTabs";

export function WeeklySchedule() {
  const locale = useDateLocale();
  const week = useScheduleStore(state => state.week);
  return (
    <section>
      <ScheduleModeTabs>
      <ScheduleSwapArea>
        <div className="min-w-0 space-y-1.5">
          {week.map(date => {
            const key = format(date, "yyyy-MM-dd");
            const day = format(date, "EEEE", { locale });
            return (
              <div key={key} className="min-w-0">
                <div className="relative z-10 inline-flex items-center gap-1.5 rounded-t border border-neutral-200 bg-neutral-50 px-2 py-1 text-[10px] leading-none">
                  <h3 className="font-bold" title={day}>{format(date, "EEE", { locale }).toUpperCase()}</h3>
                  <span aria-hidden="true" className="text-neutral-400">•</span>
                  <time dateTime={key} className="font-mono text-neutral-500">{format(date, "MMM d", { locale })}</time>
                </div>
                <div className="-mt-px min-w-0 space-y-2 rounded rounded-tl-none border border-neutral-200 bg-white p-1.5">
                  {[1, 2].map(number => <StreamSlotRow key={number} slotKey={`${key}-${number}`} number={number} day={day} />)}
                  <OfflineMessageRow dateKey={key} day={day} />
                </div>
              </div>
            );
          })}
        </div>
      </ScheduleSwapArea>
      </ScheduleModeTabs>
    </section>
  );
}
